export default function (widgetName, widgetOpts, widgetClass, targetValue) {
  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: (data) => {
      const customButtonWidgetData = data.items;

      if (!customButtonWidgetData.length) {
        return $(`#${widgetName}`).remove();
      } else {
        const { Title, URL } = customButtonWidgetData[0];

        if (!URL) {
          return $(`#${widgetName}`).remove();
        }

        $(`#${widgetName}`).replaceWith(
          `<a href='${URL}' class="button ${widgetClass}" ${targetValue ? 'target="_blank"' : ''}>${Title}</a>`,
        );
      }
    },
  });
}
